<button mat-icon-button [matMenuTriggerFor]="schemeMenu" matTooltip="Change Theme Mode">
  <mat-icon [svgIcon]="currentSchemeIcon()"></mat-icon>
</button>

<mat-menu #schemeMenu="matMenu" class="vertical-layout-menu">
  @for (scheme of schemes; track scheme.id) {
    <button
      mat-menu-item
      (click)="setScheme(scheme.id)"
      [class.bg-primary]="currentScheme() === scheme.id"
      [class.text-on-primary]="currentScheme() === scheme.id"
    >
      <div class="flex items-center">
        <mat-icon class="mr-3" [svgIcon]="scheme.icon"></mat-icon>
        <span>{{ scheme.name }}</span>
        @if (currentScheme() === scheme.id) {
          <mat-icon class="ml-auto text-sm" [svgIcon]="'heroicons_solid:check'"></mat-icon>
        }
      </div>
    </button>
  }
</mat-menu>
